export const description1 = "Zdjęcie metalowej siatki, na której powieszone są wydruki linorytowe z różnymi zwierzętami i miłymi napisami, pośrodku kartka z logo szmiry"

export const description2 = "Zdjęcie położonych na sobie kartek z odbitą linorytem małpą, poniżej czarno biała maszyna drukarska jak w ksero"

export const description3 = "Zdjęcie pracowni szmiry, w której rozłożona jest wysoka drabina, widać zwisające z sufitu dwie lampy w stylu industrialnym"